<template>
  <v-app id="vapp">
    <router-view />
  </v-app>
  <CookieConsent />
</template>

<script>
import CookieConsent from './CookieConsent.vue'

export default {
  name: 'App',
  components: {
    CookieConsent,
  },
}
</script>
<style scoped>
#vapp {
  background: #f1f1f1;
  overflow-x: hidden;
}
</style>
<style>
#vapp #main {
  transition: 0.7s ease-in-out;
}

#vapp:has(.fly-up-enter-to) #main,
#vapp:has(.fly-up-leave-from) #main {
  transform: translateY(50vh) scale(0.5);
  transition: 0s;
  filter: blur(5px);
}

button.btns-main-blue,
a.btns-main-blue {
  background-color: #1C89CC;
  border: 2px solid rgba(40, 40, 40, 0.102);
  box-shadow: none;
  color: #E5E7DF;
  text-transform: capitalize;
  font-size: 0.95rem;
  font-weight: 400;
  letter-spacing: -0.4px;
  border-radius: 16px;
  justify-content: space-between;
  transition: .2s;
}

button.btns-main-blue-large,
a.btns-main-blue-large {
  background-color: #1C89CC;
  border: 2px solid rgba(40, 40, 40, 0.102);
  box-shadow: none;
  color: #E5E7DF;
  text-transform: capitalize;
  font-size: 1.2rem;
  font-weight: 400;
  letter-spacing: -0.4px;
  border-radius: 16px;
  justify-content: space-between;
  transition: .2s;
}

button.btns-main-green,
a.btns-main-green {
  background-color: #316F46;
  border: 2px solid #316F46;
  box-shadow: 12px 11px 25px 0px rgba(49, 111, 70, 0.2);
  color: #E5E7DF;
  text-transform: capitalize;
  font-size: 0.95rem;
  font-weight: 400;
  letter-spacing: -0.4px;
  border-radius: 16px;
  justify-content: space-between;
  transition: .2s;
}

button.btns-main-green:hover,
a.btns-main-green {
  box-shadow: 12px 11px 25px 0px rgba(49, 111, 70, 0.35);
}

button.btns-main-green-large,
a.btns-main-green-large {
  background-color: #316F46;
  border: 2px solid #316F46;
  box-shadow: 12px 11px 25px 0px rgba(49, 111, 70, 0.2);
  color: #E5E7DF;
  text-transform: capitalize;
  font-size: 1.2rem;
  font-weight: 400;
  letter-spacing: -0.4px;
  border-radius: 16px;
  justify-content: space-between;
  transition: .2s;
}

button.btns-main-green-large:hover,
a.btns-main-green-large:hover {
  box-shadow: 12px 11px 25px 0px rgba(49, 111, 70, 0.35);
}

button.btns-main-white-large,
a.btns-main-white-large {
  background-color: #F2F3ED;
  border: 2px solid #2828281A;
  box-shadow: none;
  color: #316F46;
  text-transform: capitalize;
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: -0.24px;
  border-radius: 20px;
  justify-content: center;
  transition: .2s;
}

button.btns-main-white-large:hover,
a.btns-main-white-large:hover {
  box-shadow: 12px 11px 25px 0px rgba(49, 111, 70, 0.35);
}
</style>